import {useEffect, useState} from "react";
import axios from "axios";
import {API} from "../../helpers/constants";
import useUserData from "./useUserData";
import {useTranslation} from "react-i18next";
import {ALERTS} from "../../locales/components/namespaces";
import {handleAxiosErrors, logoutUnauthorizedUser} from "../../helpers/errorHandling";
import {enqueueSnackbar} from "notistack";
import useUserAction from "./useUserAction";

const useNationalities = () => {
    const {token, isLoggedIn} = useUserData()
    const {userLogout} = useUserAction()
    const {t} = useTranslation(ALERTS)
    const [loading, setLoading] = useState(false)
    const [nationalities, setNationalities] = useState([])

    useEffect(() => {
        setLoading(true)
        axios({
            method: 'get',
            headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
            url: `${API}/nationality/list`,
        }).then((response) => {
            setNationalities(response.data)
            setLoading(false)
        }).catch(error => {
            setLoading(false)
            enqueueSnackbar(handleAxiosErrors(error, t('Failed to get nationalities list.')), {
                    variant: 'error'
                }
            )
            logoutUnauthorizedUser(error, isLoggedIn, userLogout)
        })
    }, [])

    return {
        loading,
        nationalities
    }
}

export default useNationalities